import { useMemo } from 'react'

import { Banner } from '@/components/ui/banner'
import { applicationToPackage } from '../../../../../components/quotes/applicationToPackage'
import {
  applicationToQuoteCards,
  indicationsToOfferCards,
} from '../../../../../components/quotes/applicationToQuoteCards'
import { useCarrierAttestations } from '../../../../../models/attestation'
import type { InsuranceApplication } from '../../../../../models/insuranceApplication'

interface PackageStatusProps {
  orgId: string
  application: InsuranceApplication
}

/** Says why the customer's quotes page isn't showing their package; renders nothing while it is. */
export function PackageStatus({ orgId, application }: PackageStatusProps) {
  const { templates } = useCarrierAttestations(orgId)
  const carrierTermsAvailable = templates.length > 0
  const quotePackage = application.package
  // The page's own check, for blocks only the merged card knows about, such as a sibling line expiring.
  const shownOnPage = useMemo(
    () =>
      !!quotePackage &&
      !!applicationToPackage(
        quotePackage,
        indicationsToOfferCards(application.indications, carrierTermsAvailable),
        applicationToQuoteCards(application.indications, undefined, carrierTermsAvailable)
      ),
    [quotePackage, application.indications, carrierTermsAvailable]
  )
  if (!quotePackage || shownOnPage) return null

  return (
    <Banner variant="warning" small>
      {`The customer can't see this package. ${
        quotePackage.withdrawnReason ?? "One of its offers can't go in the cart on the quotes page right now."
      }`}
    </Banner>
  )
}
